function showUp(dom){
    gsap.from(dom,{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:dom,
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
        }
    })
}

function onViewLoad(className) {
    const elements = $(className).get();
    
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                const video = entry.target
                video.src = video.dataset.src
                video.load()
                observer.unobserve(video);
            }
        });
    }, { threshold:0,rootMargin: '500px', });
    
    elements.forEach(el => observer.observe(el));
}

function autoPlayOnView(className, threshold = 0.5) {
    const elements = $(className).get();
  
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.play();
          observer.unobserve(entry.target); // 播放一次后取消观察
        }
      });
    }, { threshold });
  
    elements.forEach(el => observer.observe(el));
}

var wFlag=window.innerWidth>750

onViewLoad('.lazy_video')
if(wFlag){
    onViewLoad('.lazy_video_p')
}else{
    onViewLoad('.lazy_video_m')
}

$(()=>{
    //box2
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box2_item',
            start:'top center-=10%',
            end:'+=0%',
            toggleActions:'play none none reverse',
            animation:gsap.timeline()
                .from('.box2_item div:nth-child(n+2)',{opacity:0,y:'2rem',stagger:0.2})
        })
    }

    //box3
    showUp('.box3_title')
    var box3Swiper = new Swiper('.box3Swiper', {
        autoplay: true,
        effect: 'fade',
        loop:true,
        on:{
            slideChange: function(){
                var index = this.realIndex
                $('.box3_item img').eq(index).addClass('box3Active1').siblings().removeClass('box3Active1')
                $('.box3_icon div').eq(index).addClass('box3Active').siblings().removeClass('box3Active')
            }
        },
    })
    $('.box3_icon div').click(function(){
        box3Swiper.slideTo($(this).index()+1, 300);
    })
    $('.box3_item img').click(function(){
        box3Swiper.slideTo($(this).index()+1, 300);
    })

    //box4
    var count = 2,ng_flag=true,flag_ng;
    function startNG(){
        flag_ng =  setInterval(num,100)
    }
    function num(){
        count++;
        $(`.box4_num span:first-child`).text(`${count}`)
        if(count > 9){
            clearInterval(flag_ng);
        }
    }

    if(wFlag){
        // 第一屏文字动画
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top top+=2%',
            end:'+=80%',
            scrub:1,
            animation:gsap.timeline()
                .from('.box4_img',{x:'-6%',y:'48%',scale:2,rotate:'24deg'})
        })

        ScrollTrigger.create({
            trigger:'.box4',
            start:'top top+=2%',
            end:'+=80%',
            scrub:1,
            animation:gsap.timeline()
                .from('.box4_text1',{y:'10rem',opacity:0})
                .from('.box4_text2',{y:'10rem',opacity:0})
                .to('.box4_text1',{opacity:0,y:'-10rem'},'<')
        })

        // 第二屏数字动画
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top+=90% top+=2%',
            end:'+=40%',
            scrub:1,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 10);
                if(index>8){
                    // 执行一次
                    if(ng_flag){
                        startNG()
                        ng_flag=false;
                    }
                }
                if(index<2){
                    // 重置
                    ng_flag=true,count = 2
                    $(`.box4_num span:first-child`).text(`2`)
                }
            },
            animation:gsap.timeline()
                .to('.box4_flag',{opacity:0})
                .to('.box4_flag1',{y:'-16%'},'<')
                .from('.box4_num',{opacity:0})
                .from('.box4_tips',{opacity:0},'<')
        })

        // 第三屏视频动画（跟随滚动）
        var $video = $('.box4_video');
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top+=150% top+=2%',
            end:'+=130%',
            scrub:true,
            onUpdate: function (self) {
                //console.log($video[0].duration)
                $video[0].currentTime = self.progress * 2.86;
                $('.box4_mask').toggleClass('opacity0',self.progress>0.01)
                $('.box4_title').toggleClass('opacity1',self.progress>0.6)
            }
        })

        ScrollTrigger.create({
            trigger:'.box4',
            start:'top top+=2%',
            end:'+=300%',
            pin:true
        })  
    }else{
        // 第一屏文字动画
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top top+=4%',
            end:'+=80%',
            scrub:1,
            animation:gsap.timeline()
                .from('.box4_img',{y:'18%',scale:1.5,rotate:'24deg'})
        })

        ScrollTrigger.create({
            trigger:'.box4',
            start:'top top+=4%',
            end:'+=80%',
            scrub:1,
            animation:gsap.timeline()
                .from('.box4_text1',{y:'6rem',opacity:0})
                .from('.box4_text2',{y:'10rem',opacity:0})
                .to('.box4_text1',{opacity:0,y:'-6rem'},'<')
        })

        // 第二屏数字动画
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top+=120% top+=4%',
            end:'+=60%',
            scrub:1,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 10);
                $('.box4_title').removeClass('opacity1')
                if(index>8){
                    // 执行一次
                    if(ng_flag){
                        startNG()
                        ng_flag=false;
                    }
                    // 复原下一屏视频
                    vFlag = v1Flag = false
                }
                if(index<2){
                    // 重置
                    ng_flag=true,count = 2
                    $(`.box4_num span:first-child`).text(`2`)
                }
            },
            animation:gsap.timeline()
                .to('.box4_flag',{opacity:0})
                .from('.box4_num',{opacity:0})
                .from('.box4_tips',{opacity:0},'<')
        })

        // 第三屏视频动画（自动播放）
        var vFlag = false,videoEl=$('.box4_video.mobile-only')[0],v1Flag=false
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top+=240% top+=2%',
            end:'+=10%',
            scrub:true,
            onUpdate: function (self) {
                $('.box4_mask').toggleClass('opacity0',self.progress>0.01)
                if(!vFlag){
                    vFlag = true
                    videoEl.play()
                    // 监听视频添加标题
                    $(videoEl).on('timeupdate', function () {
                        const progress = videoEl.currentTime / videoEl.duration
                        if(progress>0.8 && !v1Flag){
                            v1Flag = true
                            $('.box4_title').addClass('opacity1')
                        }
                    })
                }
                if(self.progress<0.1){
                    //vFlag = v1Flag = false
                    $('.box4_title').removeClass('opacity1')
                }
            }
        })

        ScrollTrigger.create({
            trigger:'.box4',
            start:'top top+=4%',
            end:'+=260%',
            pin:true
        })  
    }

    //box5
    //showUp('.box5_title')
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box5',
            start:'top top+=4%',
            end:'+=80%',
            pin:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 10);
                $('.box5_title').toggleClass('showUp',index>1)
                $('.box5_item img:nth-child(2)').toggleClass('showUp',index>4)
                $('.box5_item img:nth-child(3)').toggleClass('showUp',index>7)
            }
        })
    }
    showUp('.box6_title')

    //box8
    showUp('.box8_title')
    ScrollTrigger.create({
        trigger:'.box8',
        start:wFlag?'top top+=2%':'top top+=8%',
        end:'+=80%',
        pin:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 10);
            if(!wFlag){
                $('.box8_num').toggleClass('showUp',index>2)
            }
            $('.box8_info').toggleClass('showUp',index>2)
            $('.box8_bg').toggleClass('scale1',index>6)
        }
    })

    //box9
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box9',
            start:'top top+=4%',
            end:'+=100%',
            pin:true,
            scrub:1,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 10);
                $('.breath-ring').toggleClass('show',index>6)
                $('.box9_text').toggleClass('opacity1',index>6)
                $('.box9_img img:nth-child(2)').toggleClass('opacity1',index>6)
            },
            animation:gsap.timeline()
                .from('.box9_img',{rotate:'-30deg'})
                .from('.box9_title',{x:'95%'},'<')
                .from({},{duration:0.4})
        })
    }else{
        //showUp('.box9_title')
        ScrollTrigger.create({
            trigger:'.box9',
            start:'top top+=20%',
            end:'+=10%',
            toggleActions:'play none none reverse',
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 10);
                $('.breath-ring').toggleClass('show',index>9)
                $('.box9_img').toggleClass('box9_rotate',index>5)
                $('.box9_img img:nth-child(2)').toggleClass('opacity1',index>9)
            }
        })
    }

    //box10
    autoPlayOnView('.box10_video')
    showUp('.box10_title')

    //box11
    ScrollTrigger.create({
        trigger:'.box11',
        start:'top top+=15%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box11_img',{scale:0.8})
    })
    if(!wFlag){
        showUp('.box11_title')
    }
    showUp('.box12_title')

    //box13
    if(wFlag){
        var box13Swiper = new Swiper('.box13Swiper', {
        })

        ScrollTrigger.create({
            trigger:'.box13',
            start:'top top+=8%',
            end:'+=60%',
            pin:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 10);
                if(box13Swiper.activeIndex==0 && index>4){
                    box13Swiper.slideTo(1, 300, false)
                    $('.box13_video1')[0].pause()
                    $('.box13_video2')[0].play()
                }
                if(box13Swiper.activeIndex==1 && index<4){
                    box13Swiper.slideTo(0, 300, false)
                    $('.box13_video2')[0].pause()
                    $('.box13_video1')[0].play()
                }
            },
        })
    }else{
        $('.box13_video2').attr('autoplay','true')
    }

    new Swiper('.box9_1Swiper', {
        autoplay: {
            delay: wFlag?2000:1500,
            disableOnInteraction: false,
        },
        slideToClickedSlide: true,
        centeredSlides: true,
        slidesPerView:wFlag?5:1.5,
        loop:true
    })

    //box14
    showUp('.box14_title')
    if(wFlag){
        new Swiper('.box14Swiper', {
            autoplay: true,
            slidesPerView: 2,
            centeredSlides: true,
            navigation: {
                nextEl: '.box14Swiper-button-next',
                prevEl: '.box14Swiper-button-prev',
            },
            on:{
                slideChangeTransitionEnd: function () {
                
                    var $swiper = $('.box14Swiper');
                
                    $swiper.find('.box14_item video').each(function () {
                        this.pause();
                        // this.currentTime = 0;
                    });
                
                    var activeVideo = $swiper.find('.swiper-slide-active video')[0];
                    
                    if (activeVideo) {
                        activeVideo.play().catch(function () {});
                    }
    
                    $('.box14_text div').eq(this.activeIndex).addClass('show').siblings().removeClass('show')
                }
            }
        })
    }else{
        $('.box14_item video').attr('autoplay',true)
    }

    //boxSpecs_btn
    $('.bs_btn').click(function(){
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_buy').click(function(){ 
       window.open('https://store.oxva.com/products/oxva-unione'); 
    })

    $('.pnr_spec').click(function(){
        $('.Mpn_popup').css({height:'0'})
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_over2').click(function(){
        $('.Mpn_popup').css({height:'0'})
        $('.classic_section2').hide()
        $('.classic_section1').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
    })
})